module.exports = {
  FilesBaseUrl: function() {
    return '/files';
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvbGliL0NvbmZpZy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9saWIvQ29uZmlnLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixZQUFBLEVBQWMsU0FBQTtXQUFNO0VBQU4sQ0FERSJ9
